import { createFileRoute } from "@tanstack/react-router";
import AdminApiPage from "@/admin/pages/api";

export const Route = createFileRoute("/admin/api")({
  component: AdminApiPage,
});
